import {
  ConditionalAnswerType,
  CreateWSWTestInput,
  PickingStrategy,
  TestStatus,
  WSWAttributeType,
} from '../../../../API';
import {
  createDefaultStyle,
  createEmptyWswGroupConstructions,
} from '../../testAdmin/testEditor/initialEditorStates';
import { Wsw } from '../types';
import templates from './templates/smp-tempaltes';

export const wswTemplates: Wsw[] = templates;

const initialState: CreateWSWTestInput = {
  name: '',
  instructions: {
    desktop: '',
  },
  endScreen: {
    desktop: '',
  },
  description: '',
  style: createDefaultStyle(),
  status: TestStatus.DRAFT,
  additionalAttribute: {
    type: WSWAttributeType.STIMULI,
    pickingStrategy: PickingStrategy.PERMUTATION,
    categories: [],
  },
  criteriaAttribute: {
    type: WSWAttributeType.STIMULI,
    pickingStrategy: PickingStrategy.PERMUTATION,
    categories: [],
  },
  attributeCombinations: [],
  distractionPhase: {
    questionsSet: {
      questionsBefore: [],
      questionsAfter: [],
      randomizeSequence: true,
    },
  },
  groupConstruction: createEmptyWswGroupConstructions(),
  learningPhase: {
    questionOffsetTimeout: 0,
    questionsSet: {
      randomizeSequence: true,
      questionsBefore: [],
      questionsAfter: [],
    },
  },
  mainAttribute: {
    categories: [],
    pickingStrategy: PickingStrategy.PERMUTATION,
    type: WSWAttributeType.STIMULI,
  },
  testPhase: {
    questionOffsetTimeout: 0,
    feedbackScreen: {
      desktop: '',
    },
    instructionsScreen: {
      desktop: '',
    },
    questionsSet: {
      randomizeSequence: true,
      questionsBefore: [],
      questionsAfter: [],
      conditionalQuestion: {
        answerType: ConditionalAnswerType.CONFIRM,
        confirmText: 'Confirm',
        declineText: 'Decline',
        questionText: '...',
      },
    },
  },
  startLabel: 'Start',
  nextLabel: 'Next',
  finishLabel: 'Finish',
};

export default initialState;
